import { render } from "./Layout.vue?vue&type=template&id=5115618e"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/dgvt/dgvt-fuchs.de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__